/**
 * @name NoRegistersFound
 * @description Componente común que se mostrará cuando no se encuentren los registros requeridos
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

import { Unicons, Typography } from '@styles';

const NoRegistersFound = ({ direction }) => {
  return (
    <Styled.BoxNotFound direction={direction}>
      <Unicons.CircleInfo size="20" />
      <Typography.Medium>
        {i18n.t('GenericMessages.noResults')}
      </Typography.Medium>
    </Styled.BoxNotFound>
  );
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

NoRegistersFound.propTypes = {
  // Indica la dirección del componente, por defecto es 'row'
  direction: PropTypes.oneOf(['row', 'column'])
};

const Styled = {};

Styled.BoxNotFound = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: center;
  padding: 16px 0px;
  gap: ${({ direction }) => direction === 'column' ? '8px' : '12px'};
`;

export default NoRegistersFound;